import { Component, EventEmitter, ViewChild } from '@angular/core';
import { GenericManage } from '../../generic/generic.manage';
import { Partner } from '../../../model/api/documents/partner';
import { PartnerHttpService } from '../../../services/http/documents/partner.http.service';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { Param } from '../../../model/common/param';
import { PagedResult } from '../../../model/common/paged-result';

@Component({
    selector: 'app-partner-manage',
    templateUrl: 'partner.manage.html',
    providers: [ PartnerHttpService ]
})
export class PartnerManageComponent extends GenericManage<Partner, number> {

     @ViewChild('itemDetailModal') modal: ModalDirective;

    public filter: string = '';
    isCollapsed: boolean = true;

    constructor(public partnerHttpService: PartnerHttpService) {
        super();
    }

     public detailInitialize() {
        this.modal.show();
    }

    public detailTerminate() {
        this.modal.hide();
    }

    public exportToExcel() {

        let params: Array<Param> = null;

        if ((this.filter != null) && (this.filter.length > 0)) {
            params = new Array<Param>();
            params.push(new Param('filter', this.filter));
        }

        this.partnerHttpService.get(1, 1000000, 'name', 'asc', params, null).subscribe(
            (data: PagedResult<Partner>) => {

                let options = {
                    sheetid: 'furnizori',
                    headers: true,
                    column: { style: { Font: { Bold: '1' } } },
                    rows: { 1: { style: { Font: { Color: '#FF0077' } } } },
                    cells: { 1: { 1: { style: { Font: { Color: '#00FFFF' } } } } }
                };

                // alasql(`SELECT id as [Id], 
                //     name as [Denumire] 
                //     INTO XLSX("furnizori.xlsx",?) FROM ?`, [ options, data.items ]);

            });
    }

    collapsed(event: any): void {
        // console.log(event);
      }
    
      expanded(event: any): void {
        // console.log(event);
      }
}
